import React from 'react';
import Pagination from 'react-js-pagination';
import './style.css';

const Paging = ({ activePage, itemsCountPerPage, totalItemsCount, onChange }) => {
  return (
    <Pagination
      activePage={activePage}
      itemsCountPerPage={itemsCountPerPage}
      totalItemsCount={totalItemsCount}
      pageRangeDisplayed={5}
      hideNavigation={true}
      firstPageText={'«'}
      lastPageText={"»"}
      onChange={onChange}
    />
  )
}

export default Paging;